import './facebook_user_ranking_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.FacebookUserCommentedRankingChartView extends Monitoring.Views.Charts.FacebookUserRankingChartView
  className: 'chart-ranking commented-facebook-ranking item h2'
  tabs: 1

  selectedRankings: ->
    [
      new Charts.CommentedUserRanking({id:'commented_user_ranking', title:I18n.t('monitoring.dashboard.charts.ranking.most_commented'), spanSize: 12})
    ]
